import Accordion from './Accordion';

export type { AccordionProps } from './Accordion';
export default Accordion;
